<template>
  <pop-up-layout
    :title="localization.title"
    :description="localization.subtitle"
    :loading="loading"
    :saving="waitingForLoad"
    :disabled="!cambiado"
    @volver="cerrarPopup()"
  >
    <Alerts></Alerts>
    <v-col cols="12" ref="carga">
      <v-row justify="center" align="center">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="search" id="search"
            :label="localization.buscar"
          />
        </v-col>
        <v-col cols="3">
          <v-checkbox 
            v-model="seleccionarTodosMunicipios" id="seleccionarTodosMunicipios"
            clearable
            :label="localization.seleccionarTodosMunicipios"
            hide-details
            @change="seleccionarDeseleccionarTodosMunicipios()"
          />
        </v-col>
        <v-col cols="3">
          <v-autocomplete 
            v-model="poblacionFilter" id="poblacionFilter"
            :items="poblacionesInmuebles"
            multiple
            clearable
            :label="localization.segunLista"
          />
        </v-col>
      </v-row> 
      <v-row justify="center" class="px-6">
        <v-col cols="12">
          <v-layout v-if="editar">
            <v-flex >
              <h2 class="primary--text text-uppercase">
                {{localization.inmueblesEstaOperacion}}
              </h2>
            </v-flex>
          </v-layout>
          <v-divider v-if="editar" class="divider_subtitle"></v-divider>
          <v-data-table v-if="editar"
            :headers="headers"
            :search="search"
            :items="inmueblesEstaOperacion"
            item-key="inmuebleId"
            style="display: inline-block !important; width:55vw !important"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20]
            }"
            :items-per-page="5"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.inmuebleId"
                  @click="seleccionarInmueble(item)"
                  :style="selected.some(x => (x.inmuebleId === item.inmuebleId && x.inmuebleEspecialId === item.inmuebleEspecialId)) ? 'background-color: lightgray' : ''"
                >
                  <td style="max-width:200px !important; min-width: 150px !important" class="text-xs-left" v-html="item.nomInmueble" ></td>
                  <td style="max-width:200px !important; min-width: 150px !important" class="text-xs-center">{{ item.direccion }}</td>
                  <td style="max-width:200px !important; min-width: 150px !important" class="text-xs-center">{{ item.poblacion }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <v-layout>
            <v-flex >
              <h2 class="primary--text text-uppercase">
                {{checkOperacionesNoAsociadas ? localization.inmueblesNoAsociados : localization.todosInmuebles}}
              </h2>
            </v-flex>
          </v-layout>
          <v-divider class="divider_subtitle"></v-divider>
          <v-row justify="end" align="center" style="margin-bottom: -10px; padding-right: 0px; margin-right: 0px" v-if="operacion">
            <v-checkbox
              v-model="checkOperacionesNoAsociadas" id="checkOperacionesNoAsociadas" 
              :value="checkOperacionesNoAsociadas"
              class="text-end ml-12 mb-10 mt-8"
              :label="localization.inmueblesNoAsociados"
              hide-details 
            />
          </v-row>
          <v-data-table
            :headers="headersAsociados"
            :search="search"
            :items="inmueblesOperacionNombre"
            item-key="inmuebleId"
            :footer-props="{
            'items-per-page-options': [5, 10, 15, 20]
            }"
            sort-by="nombreOperacion"
            :items-per-page="5"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                    v-for="item in items"
                    :key="item.inmuebleId"
                    @click="seleccionarInmueble(item)"
                    :style="selected.some(x => (x.inmuebleId === item.inmuebleId && x.inmuebleEspecialId === item.inmuebleEspecialId)) ? 'background-color: lightgray' : ''"
                  >
                  <td style="max-width:200px !important; min-width: 150px !important" class="text-xs-left" v-html="item.nomInmueble" ></td>
                  <td style="max-width:200px !important; min-width: 150px !important" class="text-xs-center">{{ item.direccion }}</td>
                  <td style="max-width:200px !important; min-width: 150px !important" class="text-xs-center">{{ item.poblacion }}</td>
                  <td style="max-width:200px !important; min-width: 150px !important" class="text-xs-center">{{item.nombreOperacion == 'null' ? '' : item.nombreOperacion}}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="multiple">
        <v-btn
          color="primary"
          @click="todosConfirmar()"
          :disabled="deshabilitado"
        >
          {{localization.confirmButton}}
        </v-btn>
      </v-row>
    </v-col>
    <v-fade-transition>
      <ConfirmDialogOperationsUsed 
        @add="enviarRelacionadas($event)" 
        :textoTitulo="textDialog"
        @cancel="cerrarInmueblesYaAsociados()" 
        :dialogFlag="popUpInmueblesYaAsociados" 
        :itemAdd="inmueblesUsadosOtraOperacion" 
      />
    </v-fade-transition>
  </pop-up-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import ConfirmDialogOperationsUsed from '../custom/confirmDialogOperationsUsed'
import Alerts from '@/components/Alerts'

export default {
  components: {
    Alerts,
    ConfirmDialogOperationsUsed
  },
  mixins: [rulesMixin],
  props: {
    promoId: {
      type: String,
      required: true
    },
    yaSeleccionado: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    operacion: {
      type: Boolean,
      default: false
    },
    editar: {
      type: Boolean,
      default: false
    },
    operacionAEditar: {
      type: Object,
      default:() => {}
    }
  },
  data () {
    return {
      waitingForLoad: false,
      loading: false,
      search: null,
      selected: [],
      items: [],
      poblacionFilter: [],
      seleccionarTodosMunicipios: false,
      checkOperacionesNoAsociadas: true,
      popUpInmueblesYaAsociados: false,
      inmueblesUsadosOtraOperacion: [],
      inmueblesABorrar: [],
      inmuebleSelectedIds: [],
      textDialog: '',
      operacionEnviar: {},
    }
  },
  mounted(){
    this.getOperaciones()
  },
  async created () {
    try {
      this.loading = true
      await this.getPropertiesByIdPromotion(this.promoId)
        this.selected = this.yaSeleccionado.length !== 0 ? this.inmueblesPorPromo.filter(x => {
          return this.yaSeleccionado.some(y => {
            if (y !== null) {
              return x.inmuebleId === y
            } 
          })
        }) : []
      this.loading = false
    } catch (error) {
      this.addAlert({ texto: 'Hubo un error al cargar los inmuebles.', color: 'error' })
    }
  },
  computed: {
    ...mapGetters({
      getConfiguracion: 'configuracion/getConfiguracion'
    }),
    localization () {
      return this.$t('popUpSeleccionarInmueble')
    },
    headers () {
      return [
        {text: this.localization.headerInmueble, value: 'nomInmueble', sortable: true, align: 'LEFT'},
        {text: this.localization.headerDireccion, value: 'direccion', sortable: true, align: 'LEFT'},
        {text: this.localization.headerPoblacion, value: 'poblacion', sortable: true, align: 'LEFT'},
        
      ]},
    
    headersAsociados(){
      
        return [
        {text: this.localization.headerInmueble, value: 'nomInmueble', sortable: true, align: 'LEFT'},
        {text: this.localization.headerDireccion, value: 'direccion', sortable: true, align: 'LEFT'},
        {text: this.localization.headerPoblacion, value: 'poblacion', sortable: true, align: 'LEFT'},
        {text: 'OPERACIÓN', value: 'nombreOperacion', sortable: true, align: 'LEFT'} 
      ]
    },
    deshabilitado(){
      if(this.selected.length === 0)
      return true
      else {
        return false
      }
    },
    inmueblesPorPromo () {
      if (this.$store.state.incidencias.propertiesByStringAndPropDevId) {
        let inm = this.$store.state.incidencias.propertiesByStringAndPropDevId
        if ( this.poblacionFilter.length > 0 ) {
          let aux = []
          inm.forEach(item => {
              if ( this.poblacionFilter.includes(item.poblacion) === true ) {
                aux.push(item)
              } 
            })
          return aux
        }
        else {
          return [...new Map(inm.map(item => [item['inmuebleId'], item])).values()]
        }
      }
      return []
    },
    inmueblesOperacion(){
      if(this.checkOperacionesNoAsociadas === true){
        let inmueblesUsados = []
        this.operaciones.forEach(x =>{x.inmueblesIds.forEach(y=>{inmueblesUsados.push(y)}) })
        let inmueblesNoUsados = this.inmueblesPorPromo.filter(x=> !inmueblesUsados.includes(x.inmuebleId))
        inmueblesNoUsados = inmueblesNoUsados.map(x=> {return {...x, nombreOperacion: null}})
        return inmueblesNoUsados
      }else{
        if(this.editar){
          let inmueblesAjenosEstaOperacion = []
        this.inmueblesPorPromo.forEach(x => { 
          if(this.yaSeleccionado.includes(x.inmuebleId) === false){
      
            inmueblesAjenosEstaOperacion.push(x)
            
            }})
        return inmueblesAjenosEstaOperacion
        }else{
          return this.inmueblesPorPromo}
      }
      
    },
    inmueblesOperacionNombre(){
      return this.inmueblesOperacion.map(x => {
          return {
            ...x,
            nombreOperacion: x.operacionId === null ? 'null' :  this.allOperaciones.find(y => y.id === x.operacionId).code 
          }
        })
    },
    poblacionesInmuebles () {
      let inmuebles = []
      let aux = []
        if ( this.$store.state.incidencias.propertiesByStringAndPropDevId != null) {
          inmuebles = this.$store.state.incidencias.propertiesByStringAndPropDevId
        }
      if ( inmuebles.length > 0 ) {
        inmuebles.forEach(inmueble => {
          if ( inmueble.poblacion !== null && inmueble.poblacion.trim() !== "") {
            aux.push(inmueble.poblacion)
          }
        })
      }
      return aux
    },
    cambiado () {
      return this.yaSeleccionado !== this.selected
    },
    operaciones(){
      if (this.$store.state.gestion.operations) {
        let operacionesSinFiltrar = this.$store.state.gestion.operations
        
        let result = operacionesSinFiltrar.reduce((unique, o) => {
        if(!unique.some(obj => obj.clienteId === o.clienteId && obj.code === o.code && obj.promocionId === o.promocionId && obj.ambitoOperacionId === o.ambitoOperacionId) ) {
          o.inmueblesIds = [o.inmuebleId]
          unique.push(o);
        } else {
          unique.find(x=> x.code === o.code).inmueblesIds.push(o.inmuebleId)
        }
        return unique;
        },[]) 
      if(this.promoId == null){
        return result
      }
      else{
        return result.filter(x => {return x.promocionId === this.promoId})
      }
      }
      return null
    },
    allOperaciones(){
      if (this.$store.state.gestion.operations) {
        return this.$store.state.gestion.operations
      }
      else{return []}
    },
    inmueblesEstaOperacion(){
      if(this.editar)
      {
        let inmueblesDeEstaOperacion = []
        this.inmueblesPorPromo.forEach(x => { if(this.yaSeleccionado.includes(x.inmuebleId)){inmueblesDeEstaOperacion.push(x)}})
        return inmueblesDeEstaOperacion
      }else{
        return []
        }
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getPropertiesByIdPromotion: 'incidencias/getPropertiesByIdPromotion',
      getOperaciones: 'gestion/getOperaciones',
      checkOperationPropertyUsed: 'gestion/checkOperationPropertyUsed',
      checkOperationsWillBeDeleted: 'gestion/checkOperationsWillBeDeleted',
      delOperationIdsArray: 'gestion/delOperationIdsArray', 
    }),
    cerrarInmueblesYaAsociados(){
      this.loader.hide()
      this.popUpInmueblesYaAsociados = false
      this.inmuebleSelectedIds = []
    },
    cerrarPopup() {
      this.$parent.hide()
      this.$parent.$parent.sheet = true
    },
    seleccionarInmueble (inmueble) {
      const alquiler = this.getConfiguracion.tiposIncidenciaAlquiler
      const sinOperacion = this.getConfiguracion.tiposIncidenciaSinOperacion
      const venta = this.getConfiguracion.tiposIncidenciaVenta
      /** 421427 - Al seleccionar un inmueble para introducir una visita, figura error al no tener definida la tipología de visita. */  
      if(
        (inmueble.ambito === 0 && sinOperacion.length <= 0) ||
        (inmueble.ambito === 1 && venta.length <= 0) ||
        (inmueble.ambito === 2 && alquiler.length <= 0)
      ) {
        this.addAlert({texto: 'No existen tipos de visita asociados a este inmueble, por favor, revise la configuración.', color: 'error'})
      } else {
        if (this.multiple) {
          if (this.selected.some(x => {
            if (x.inmuebleId !== null) {
              return x.inmuebleId === inmueble.inmuebleId
            } 
          })) {
            let index = this.selected.indexOf(inmueble)
            this.selected.splice(index, 1)
          } else {
            this.selected.push(inmueble)
          }
        } else {
          this.$emit('selected', inmueble)
          this.$parent.hide()
        }
      }
    },
    confirmar () {
      this.$emit('selected', this.selected)
      this.$parent.hide()
    },

    async enviarRelacionadas(seleccionadas)
    {
      this.loading = true
      await this.delOperationIdsArray(seleccionadas)
      await this.delOperationIdsArray(this.inmueblesABorrar)
      let inmueblesSinUsar = this.inmuebleSelectedIds.filter((o) => this.operacionAEditar.inmueblesIds.indexOf(o) === -1)
      let idsSeleccionados = []
      seleccionadas.forEach(x=>{ idsSeleccionados.push(x.inmuebleId)})
      let inmueblesOtraOperacion = []
      this.inmueblesUsadosOtraOperacion.forEach(x=>{ inmueblesOtraOperacion.push(x.inmuebleId)})
      let excluido = []
      excluido = inmueblesOtraOperacion.filter(o => !idsSeleccionados.includes(o))
      let aEnviar = []
      aEnviar = inmueblesSinUsar.filter(o => !excluido.includes(o))
        this.operacionEnviar = {
          code: this.operacionAEditar.code,
          clienteId: this.operacionAEditar.clienteId,
          inmuebleId: aEnviar,
          ambitoOperacionId: this.operacionAEditar.ambitoOperacionId,
        }
        this.$emit('selected', this.operacionEnviar)
        this.loading = false
        this.cerrarPopup()
    },
  async todosConfirmar()
  {
    if(!this.editar)
    {
      this.loading = true
      await this.confirmar()
      this.loading = false
    } else {
      await this.confirmarUpdate()
    }  
  },
    async confirmarUpdate(){
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.carga,
        canCancel: false,
        onCancel: this.onCancel
      })
      this.inmueblesUsadosOtraOperacion = []
      this.inmueblesABorrar= []
      this.selected.forEach(inm => this.inmuebleSelectedIds.push(inm.inmuebleId))
      let values = {
        inmuebleId: this.inmuebleSelectedIds,
        code: this.operacionAEditar.code
      }
      this.inmueblesUsadosOtraOperacion = await this.checkOperationPropertyUsed(values)
      this.inmueblesABorrar = await this.checkOperationsWillBeDeleted(values)  
      if(this.inmueblesUsadosOtraOperacion.length != 0 )
        {
          this.inmueblesUsadosOtraOperacion = this.inmueblesUsadosOtraOperacion.map(x => {
            return {
            ...x,
            nombreInmueble: this.inmueblesPorPromo.find(y => y.inmuebleId === x.inmuebleId).uhedit,
            check: true    
          }
        })
          this.textDialog = this.localization.inmueblesAsociadosEncontrados
          this.loader.hide()
          this.popUpInmueblesYaAsociados = true
          return
        }
      if(this.inmueblesABorrar.length != 0){
        this.inmueblesABorrar = this.inmueblesABorrar.map(x => {
          return {
            ...x,
            nombreInmueble: this.inmueblesPorPromo.find(y => y.inmuebleId === x.inmuebleId).uhedit
          }
        })
        }
        await this.delOperationIdsArray(this.inmueblesABorrar)
        let inmueblesSinUsar = this.inmuebleSelectedIds.filter((o) => this.operacionAEditar.inmueblesIds.indexOf(o) === -1)
       
        this.operacionEnviar = {
          code: this.operacionAEditar.code,
          clienteId: this.operacionAEditar.clienteId,
          inmuebleId: inmueblesSinUsar,
          ambitoOperacionId: this.operacionAEditar.ambitoOperacionId,
        }
        this.$emit('selected', this.operacionEnviar) 
        this.loader.hide()
        this.cerrarPopup()
        return
      }
    },
    seleccionarDeseleccionarTodosMunicipios () {
        let municipios = []
        if (this.seleccionarTodosMunicipios === true) {
            this.poblacionFilter = []
            municipios = this.poblacionesInmuebles
            municipios.forEach(municipio => {
              if ( this.poblacionFilter.includes(municipio) === false ) {
                this.poblacionFilter.push(municipio)
              }
            });
        }
        else {
            this.poblacionFilter = []
        }
    },
}
</script>

<style scoped>
  .info-tooltip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
    margin-bottom: 0px;
  }
</style>